<template>
	<div>
		<BaseAccordionController
			:accordion_header="
				getStateWithParam('volunteering_previous_applications_label')
			"
		>
			<template v-slot:component>
				<v-container class="card-wrapper" grid-list-lg>
					<topicApplications class="pb-1"> </topicApplications>
					<initiativeApplications
						class="pb-1"
					></initiativeApplications>
				</v-container>
			</template>
		</BaseAccordionController>
	</div>
</template>

<script>
import topicApplications from "./topic-applications.vue";
import initiativeApplications from "./initiative-applications.vue";

export default {
	name: "volunteeringApplications",
	components: { topicApplications, initiativeApplications },
	data() {
		return {
			applications: [],
		};
	},
	created() {},
	computed: {},
	methods: {
		getStateWithParam(param) {
			return this.$store.getters.getLanguageParameters(param);
		},
	},
};
</script>

<style lang="scss" scoped>
.application-card {
	background-color: #ffffff;
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
	border-radius: 8px;
	padding: 16px;
	margin-bottom: 16px;
	transition: box-shadow 0.3s ease;
	position: relative;
}

.application-card:hover {
	box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

.card-content {
	flex-grow: 1;
}

.bolded-text {
	font-weight: bold;
}

.card-title {
	font-size: 18px;
	margin-bottom: 8px;
}

.card-subtitle {
	margin-bottom: 8px;
}

.card-actions {
	position: absolute;
	bottom: 25px;
	right: 8px;
}

.delete-button {
	background-color: #f74c4c;
	color: #fff;
	padding: 8px 12px;
	border: none;
	border-radius: 4px;
	cursor: pointer;
	transition: background-color 0.3s ease;
}

.delete-button v-icon {
	vertical-align: middle;
}
</style>
